"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2166],{

/***/ 82521:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55757);


//mui





const LocationInput = (param)=>{
    let { location , setLocation  } = param;
    const { t  } = useTranslation();
    return /*#__PURE__*/ _jsxs(FormControl, {
        children: [
            /*#__PURE__*/ _jsx(FormLabel, {
                id: "demo-radio-buttons-group-label",
                className: "pb-[30px]",
                children: /*#__PURE__*/ _jsx("span", {
                    className: "text-[#9B9B9B] text-base tracking-wider capitalize ",
                    children: t("Localisation")
                })
            }),
            /*#__PURE__*/ _jsx(FormControl, {
                variant: "contain",
                children: /*#__PURE__*/ _jsx(FormControl, {
                    variant: "outlined",
                    children: /*#__PURE__*/ _jsx(OutlinedInput, {
                        value: location,
                        onChange: (event)=>setLocation(event.target.value),
                        placeholder: t("Adresse, i.e Bab E-zouar"),
                        sx: {
                            fieldset: {
                                border: "none",
                                outline: "none"
                            },
                            borderRadius: "15px",
                            background: "#F7EFFA",
                            fontSize: "14px",
                            fontFamily: "Myriad Pro",
                            marginTop: "1rem"
                        },
                        startAdornment: /*#__PURE__*/ _jsx(InputAdornment, {
                            position: "start",
                            children: /*#__PURE__*/ _jsx("img", {
                                src: "/svg/location.svg",
                                alt: "location",
                                className: "cursor-pointer"
                            })
                        }),
                        "aria-describedby": "outlined-weight-helper-text",
                        inputProps: {
                            "aria-label": "weight"
                        }
                    })
                })
            })
        ]
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (LocationInput)));


/***/ }),

/***/ 63096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const Pagination = (param)=>{
    let { count , pagesize , setPage , page , showPages =3  } = param;
    // console.log("count", count);
    const pages = (currentPage, last)=>{
        var list = [];
        var Lastcell = null;
        for(var i = 1; i <= last; i++){
            if (i === 1 || currentPage + 1 === 1 && i <= showPages || i === last || currentPage + 1 === last && i >= last - (showPages - 1) || i === currentPage + 1 || !(i <= currentPage + 1 - Math.ceil(showPages / 2)) && i <= currentPage || !(i >= currentPage + 1 + Math.floor(showPages / 2) + 1) && i >= currentPage) {
                list.push(i);
                Lastcell = "".concat(i);
            } else {
                if (Lastcell !== "...") {
                    list.push("...");
                    Lastcell = "...";
                }
            }
        }
        return list === null || list === void 0 ? void 0 : list.map((item, index)=>item === "..." && list[index + 1] - list[index - 1] === 2 ? list[index - 1] + 1 : item);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex items-center border border-[#D4D4D8] h-[40px] rounded-[10px] w-fit",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                type: "button",
                onClick: ()=>{
                    if (page + 1 > 1) setPage(page - 1);
                },
                disabled: page > 0 ? false : true,
                className: " h-full w-[40px] border-r border-r-[#D4D4D8] flex items-center justify-center \n        ".concat(page > 0 ? "flex" : "hidden", "\n        "),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/svg/arrow-left-black.svg",
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "h-full flex flex-row items-center justify-center",
                children: pages(page, Math.ceil(count / pagesize)).map((pageCell, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Cell, {
                        setPage: setPage,
                        page: page,
                        number: pageCell
                    }, index))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                type: "button",
                onClick: ()=>{
                    if (page + 1 < Math.ceil(count / pagesize)) setPage(page + 1);
                },
                disabled: page + 1 < Math.ceil(count / pagesize) ? false : true,
                className: " h-full w-[40px] border-l border-l-[#D4D4D8] flex items-center justify-center \n        ".concat(page + 1 < Math.ceil(count / pagesize) ? "flex" : "hidden", "\n        "),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/svg/arrow-right-black.svg",
                    alt: ""
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Pagination);
const Cell = (param)=>{
    let { setPage , page , number  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        type: "button",
        disabled: number === "..." || page + 1 === number ? true : false,
        onClick: ()=>{
            setPage(number - 1);
        },
        className: "h-full w-[40px] border-r border-r-[#D4D4D8] flex items-center justify-center".concat(page + 1 === number ? "h-full w-[40px] border-r border-r-[#D4D4D8] flex items-center justify-center bg-secondary text-white" : number === "..." ? "h-full w-[40px] border-r border-r-[#D4D4D8] flex items-center justify-center" : "h-full w-[40px] border-l border-l-[#D4D4D8] flex items-center justify-center", " "),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            children: number
        })
    });
};


/***/ }),

/***/ 12166:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "wh": function() { return /* reexport */ allHomesSkeleton; },
  "tl": function() { return /* reexport */ Pagination/* default */.Z; },
  "gI": function() { return /* reexport */ topRatingSkeleton; },
  "a5": function() { return /* reexport */ feed_UserFeedSkeleton; }
});

// UNUSED EXPORTS: AboutUs, FindUs, Footer, Header, JoinUs, Loading, LocationInput

// EXTERNAL MODULE: ./components/Header.jsx + 4 modules
var Header = __webpack_require__(68571);
// EXTERNAL MODULE: ./components/Footer.jsx
var Footer = __webpack_require__(37127);
// EXTERNAL MODULE: ./components/AboutUs.jsx
var AboutUs = __webpack_require__(47702);
// EXTERNAL MODULE: ./components/FindUs.jsx
var FindUs = __webpack_require__(4547);
// EXTERNAL MODULE: ./components/JoinUs.jsx
var JoinUs = __webpack_require__(80079);
// EXTERNAL MODULE: ./components/LocationInput.jsx
var LocationInput = __webpack_require__(82521);
// EXTERNAL MODULE: ./components/Pagination.jsx
var Pagination = __webpack_require__(63096);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./hooks/useTranslation.js + 2 modules
var useTranslation = __webpack_require__(55757);
// EXTERNAL MODULE: ./node_modules/@mui/material/Skeleton/Skeleton.js + 2 modules
var Skeleton = __webpack_require__(88078);
;// CONCATENATED MODULE: ./components/skeletonComp/feed/UserFeedSkeleton.jsx




const UserFeedSkeleton = ()=>{
    const { t  } = (0,useTranslation/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full hidden lg:block bg-white rounded-[30px] py-[34px] px-[33px] border border-[#C1C1C1]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col h-full",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col items-center gap-4 border-b-[0.5px] border-[#923FB34A] pb-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-16 h-16 bg-[#E7D5EEB8] rounded-full flex justify-center items-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                className: "w-full h-full",
                                variant: "circular"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-row gap-3",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                            className: "w-14"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                            className: "w-14"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-primary font-MyriadPro text-sm tracking-widest hidden lg:block my-3 px-6 py-1 rounded-full bg-[#F7EFFA] ",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                        className: "w-16"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col gap-2 pt-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-full flex justify-between items-center text-sm tracking-widest text-black",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "capitalize",
                                    children: t("service succ\xe8s")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "font-semibold capitalize flex gap-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                className: "w-3"
                                            })
                                        }),
                                        t("services")
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-full flex justify-between items-center text-sm tracking-widest text-black",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: t("Rating")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center gap-1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "/svg/star.svg",
                                            alt: "star"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                            className: "w-3"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-full flex justify-between items-center text-sm tracking-widest text-black",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: t("Member depuis")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                    className: "w-16"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var feed_UserFeedSkeleton = (UserFeedSkeleton);

;// CONCATENATED MODULE: ./components/skeletonComp/sendOfer/allHomesSkeleton.jsx





const AllHomesSkeleton = ()=>{
    const { traduction  } = (0,useTranslation/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative w-full lg:w-2/3 h-48 bg-[#F9F9F9] rounded-md border border-[#E6E6E6] p-6 flex justify-between space-x-4 cursor-pointer",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "h-20 ml-4 ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-[20px] h-[20px] rounded-full bg-[#D9D9D9] flex justify-center items-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/svg/cube.svg"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-max h-10 border-l-2 border-dashed border-[#D9D9D9] mx-auto"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-[20px] h-[20px] rounded-full bg-primary bg-opacity-20 flex justify-center items-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/svg/locationIcon.svg"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full space-y-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "h-20 flex flex-col justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                width: 100,
                                variant: "text"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                width: 145,
                                variant: "text"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full flex justify-between items-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex justify-between space-x-1 items-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "/svg/pieceIcon.svg"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                    width: 10,
                                    variant: "text"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-xs text-[#707070] font-semibold",
                                    children: traduction("pieces")
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var allHomesSkeleton = (AllHomesSkeleton);

// EXTERNAL MODULE: ./components/Loading.jsx
var Loading = __webpack_require__(52049);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(21082);
// EXTERNAL MODULE: ./node_modules/swiper/modules/navigation/navigation.min.css
var navigation_min = __webpack_require__(21669);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(36797);
// EXTERNAL MODULE: ./node_modules/swiper/modules/scrollbar/scrollbar.min.css
var scrollbar_min = __webpack_require__(91712);
;// CONCATENATED MODULE: ./components/skeletonComp/topRating/topRatingSkeleton.jsx


//swiper







const TopRatingSkeleton = ()=>{
    const { t  } = (0,useTranslation/* default */.Z)();
    const swiperRef = (0,react.useRef)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "py-24 best-slider",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex w-full",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col items-center gap-16 w-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-xl text-dark font-bold uppercase tracking-[0.18em]",
                        children: t("les mieux not\xe9s")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative flex justify-center container mx-auto",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "max-w-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                ref: swiperRef,
                                slidesPerView: 3,
                                spaceBetween: 35,
                                loop: true,
                                breakpoints: {
                                    0: {
                                        slidesPerView: 1
                                    },
                                    640: {
                                        slidesPerView: 2
                                    },
                                    1200: {
                                        slidesPerView: 3
                                    }
                                },
                                autoplay: {
                                    delay: 4000,
                                    disableOnInteraction: false
                                },
                                children: [
                                    ...Array(3).keys()
                                ].map((it, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "block card",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                style: {
                                                    borderRadius: "30px"
                                                },
                                                className: "flex flex-col w-[346px] h-[457px] bg-white border border-[#BBBBBB] rounded-lg",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        style: {
                                                            borderRadius: "30px 30px 0px 0px"
                                                        },
                                                        className: "h-48 relative ",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "absolute z-10 right-4 top-4",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "bg-white py-[6px] px-[9px] rounded-[100px] flex items-center gap-1",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                            src: "/svg/star.svg",
                                                                            alt: "star",
                                                                            className: "w-5 h-5 mb-[0.5px]"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                                            width: 15
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                                width: 346,
                                                                className: "w-full h-full",
                                                                variant: "rectangular",
                                                                sx: {
                                                                    backgroundColor: "#cec8c8",
                                                                    borderRadius: "30px 30px 0px 0px"
                                                                }
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        style: {
                                                            borderRadius: "0px 0px 30px 30px"
                                                        },
                                                        className: "px-7 py-3",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "flex flex-col items-center gap-1 h-full ",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                                    width: 180,
                                                                    variant: "rounded"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                                    width: 80,
                                                                    variant: "text"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                    className: "text-sm text-[#727272] line-clamp-3 h-[60px] w-full",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                                            width: "100%",
                                                                            variant: "text"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                                            width: "100%",
                                                                            variant: "text"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                                            width: "60%",
                                                                            variant: "text"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "flex items-center gap-2 py-4 text-lg text-[#ADADAD]",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                                            width: "14",
                                                                            height: "16",
                                                                            viewBox: "0 0 14 16",
                                                                            fill: "none",
                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                                fillRule: "evenodd",
                                                                                clipRule: "evenodd",
                                                                                d: "M7.39804 15.804C8.88097 15.0348 14 12.0163 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 12.0163 5.11903 15.0348 6.60196 15.804C6.85483 15.9351 7.14517 15.9351 7.39804 15.804ZM7 10C8.65685 10 10 8.65685 10 7C10 5.34315 8.65685 4 7 4C5.34315 4 4 5.34315 4 7C4 8.65685 5.34315 10 7 10Z",
                                                                                fill: "#273B4A"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                                            width: 160,
                                                                            variant: "text"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "bg-secondary text-white py-[17px] w-full font-semibold text-xl rounded-lg ha:hover:bg-primary duration-300 text-center",
                                                                    children: t("Voir plus")
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    }, i))
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var topRatingSkeleton = (TopRatingSkeleton);

;// CONCATENATED MODULE: ./components/index.js














/***/ })

}]);